import type { ColumnDef } from "@tanstack/react-table";
import type { ApInvoice } from "@/accounts-payable/types";
import { formatCentsOrDashIfZero } from "@/core/utils/money";
import { cn } from "@/core/utils/utils";

export const totalCol: ColumnDef<ApInvoice> = {
  accessorKey: "total_amount_cents",
  // Right-aligned to the label, clear of the sort arrow (16px + 8px gap).
  header: () => <span className="flex-1 text-right">Total</span>,
  meta: { size: "120px" },
  cell: ({ row }) => (
    <span
      className={cn("block pr-6 text-right font-semibold tabular-nums", {
        "text-negative-text": row.original.total_amount_cents < 0,
      })}
    >
      {formatCentsOrDashIfZero(row.original.total_amount_cents)}
    </span>
  ),
};
